import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-style-combinations',
  templateUrl: './style-combinations.component.html',
})
export class StyleCombinationsComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.combinationDescOne?.replaceAll("\n","<br />") ?? '';
  }

}
